"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QualityEducation = void 0;
var React = __importStar(require("react"));
var QualityEducation = function (_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "48",
    height: "48",
    viewBox: "0 0 498.9 604"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
    fill: "#C11728",
    points: "251.5,329.6 121.3,254.1 121.3,498.2 251.5,537.6"
  }), React.createElement("polygon", {
    fill: "#C11728",
    points: "265.8,330.1 265.8,537.7 396.7,498.1 396.7,254.1"
  }), React.createElement("polygon", {
    fill: "#C11728",
    points: "471.9,493.8 468.1,493.8 483.5,547.9 498.9,493.8 495,493.8 498.9,493.8 498.9,276.7 \n      495,276.7 491.2,276.7 487.2,276.7 479.5,276.7 475.7,276.7 471.9,276.7 468.1,276.7 468.1,493.8"
  }), React.createElement("polygon", {
    fill: "#C11728",
    points: "424.7,264.6 410.7,253.6 410.7,504.8 266.2,551.7 259.5,551.7 258.1,551.7 \n      251.5,551.7 107.5,511.3 107.5,253.6 93.6,264.6 93.6,521.1 250.8,564.8 258.1,564.8 259.5,564.8 266.8,564.8 411.9,518.6 \n      424.7,514.8"
  }), React.createElement("g", null, React.createElement("path", {
    fill: "#C11728",
    d: "M498.9,247.9c0-8.5-6.9-15.5-15.4-15.5s-15.4,6.9-15.4,15.5v16.7h30.8L498.9,247.9\n        L498.9,247.9z"
  }), React.createElement("path", {
    fill: "#C11728",
    d: "M21.6,103.8l22-60.4h0.2v60.4H21.6z M43.4,146.9h23.3v-23.8h9.9v-19.3h-9.9V0H42.5L0,107.9\n        v15.2h43.4V146.9z"
  }), React.createElement("path", {
    fill: "#C11728",
    d: "M164.3,49.4V15.9c0-3.7-1.6-6.3-5.3-6.3c-3.6,0-5.2,2.6-5.2,6.3v33.5c0,3.6,1.6,6.3,5.2,6.3\n        C162.7,55.8,164.3,53,164.3,49.4z M155.2,67.3v-4.2c-8.2-1.4-11.7-7.5-11.7-15.8V17.6C143.5,8,148.2,1,159,1\n        c10.9,0,15.6,7,15.6,16.6v29.7c0,6.7-2.3,12-7.6,14.5l7.6,1.4v7.7L155.2,67.3z"
  }), React.createElement("path", {
    fill: "#C11728",
    d: "M210.3,1.7v46.5c0,9.5-4.1,15.7-14.5,15.7c-10.8,0-15.3-6.2-15.3-15.7V1.7h10.3v47.5\n        c0,3.6,1.4,6.1,5.1,6.1c3.6,0,5-2.4,5-6.1V1.7H210.3z"
  }), React.createElement("path", {
    fill: "#C11728",
    d: "M226.1,43.6h8.2L230.2,19h-0.1L226.1,43.6z M213.2,63.1l11.6-61.4h11.7l11.6,61.4h-10.5\n        l-1.9-11.2h-10.9L223,63.1H213.2z"
  }), React.createElement("polygon", {
    fill: "#C11728",
    points: "252.3,1.7 262.6,1.7 262.6,54.7 274.9,54.7 274.9,63.1 252.3,63.1"
  }), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#C11728",
    points: "279.6,63.1 289.8,63.1 289.8,1.7 279.6,1.7"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#C11728",
    points: "294.6,1.7 321.9,1.7 321.9,10.1 313.5,10.1 313.5,63.1 303.1,63.1 303.1,10.1 \n          294.6,10.1"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#C11728",
    points: "346.7,39.7 346.7,63.1 336.5,63.1 336.5,39.7 325,1.7 335.7,1.7 342,25 342.1,25 \n          348.3,1.7 358.1,1.7"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#C11728",
    points: "143.5,87.7 168,87.7 168,96.1 153.8,96.1 153.8,113.7 164,113.7 164,122 \n          153.8,122 153.8,140.7 168,140.7 168,149.1 143.5,149.1"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#C11728",
    d: "M188.1,140.7c4.2,0,5.9-2.5,5.9-6.2v-32.1c0-3.6-1.6-6.2-5.9-6.2h-4.3v44.5H188.1z\n            M204.3,104.2v28.4c0,9.4-3.9,16.5-14.9,16.5h-15.9V87.7h15.9C200.4,87.7,204.3,94.7,204.3,104.2z"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#C11728",
    d: "M240,87.7v46.5c0,9.5-4.1,15.7-14.5,15.7c-10.8,0-15.3-6.2-15.3-15.7V87.7h10.3v47.5\n          c0,3.6,1.4,6.1,5,6.1s5.1-2.4,5.1-6.1V87.7H240z"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#C11728",
    d: "M245.8,133.3v-29.7c0-9.6,4.5-16.6,15.3-16.6c11.4,0,14.5,6.3,14.5,15.4v7.2h-9.4v-8.1\n          c0-3.8-1.3-6-5-6s-5.2,2.6-5.2,6.3v33c0,3.7,1.5,6.3,5.2,6.3s5-2.4,5-6v-11.3h9.4v10.6c0,8.8-3.6,15.3-14.5,15.3\n          C250.3,149.8,245.8,142.8,245.8,133.3"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#C11728",
    d: "M291.7,129.6h8.2l-4.1-24.6h-0.1L291.7,129.6z M278.8,149.1l11.5-61.4H302l11.6,61.4h-10.5\n          l-1.9-11.2h-10.9l-1.8,11.2H278.8z"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#C11728",
    points: "312.2,87.7 339.5,87.7 339.5,96.1 331.1,96.1 331.1,149.1 320.7,149.1 320.7,96.1 \n          312.2,96.1"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#C11728",
    points: "344.3,149.1 354.6,149.1 354.6,87.7 344.3,87.7"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#C11728",
    d: "M381.4,134.9v-33c0-3.7-1.6-6.3-5.3-6.3c-3.6,0-5.2,2.6-5.2,6.3v33c0,3.7,1.6,6.3,5.2,6.3\n          C379.8,141.2,381.4,138.6,381.4,134.9 M360.5,133.3v-29.7c0-9.6,4.7-16.6,15.5-16.6c10.9,0,15.6,7,15.6,16.6v29.7\n          c0,9.5-4.7,16.6-15.6,16.6C365.2,149.8,360.5,142.8,360.5,133.3"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#C11728",
    points: "406.2,110.5 406.2,149.1 397.5,149.1 397.5,87.7 407.6,87.7 418.7,122.9 \n          418.7,87.7 427.3,87.7 427.3,149.1 418.3,149.1"
  }))))));
};
exports.QualityEducation = QualityEducation;